<template>
  <HeaderComponent v-show="!painelTvChrome.ativo" :moduleName="$moduleName" :buildMode="envMode" />

  <main id="main" :class="{ 'painel-tv-main': painelTvChrome.ativo }">
    <MenuLateral :menuData="menus">
      <!-- <template #extra="{ menu = {} }">
              <span v-if="menu && menu.label === 'Painel Injetora'" style="display: inline-flex; flex-direction: row; justify-content: space-around; flex-wrap: nowrap; gap: 8px; white-space: nowrap;">
                <span style="background-color: var(--cor-alerta); width: 25px; height: 25px; border-radius: 4px; color: black; text-align: center;" > 0</span>
                <span style="background-color: var(--cor-sucesso); width: 25px; height: 25px; border-radius: 4px; color: white; text-align: center;" > 3</span>
                <span style="background-color: var(--cor-erro); width: 25px; height: 25px; border-radius: 4px; color: white; text-align: center;" > 1</span>
              </span>
            </template> -->
    </MenuLateral>
    <RouterView />
  </main>
</template>

<script>
import { HeaderComponent, MenuLateral } from "roboflex-thalamus-componentes-vue3-lib";
import { RouterView } from "vue-router";
import { painelTvChrome } from "@/state/painelTvChrome";

export default {
  name: "App",
  components: {
    MenuLateral,
    HeaderComponent,
    RouterView,
  },
  data() {
    return {
      painelTvChrome,
      // envMode: process.env.NODE_ENV,
      envMode: "production",
      menus: [
        {
          icone: "icone-input",
          subMenus: [
            { label: "Painel Injetora", route: "/painel-injecao", extra: "<>" },
            { label: "KPIs gestão produção", route: "/gestao-producao-kpis", funcionalidade: 245 },
            // { label: "Metas de produção", route: "/metas-producao" },
            { label: "Apontamento Injeção", route: "/painel-edicao", funcionalidade: 62 },
            { label: "Peças não conformes", route: "/inconformidades", funcionalidade: 200 },
            // { label: "Painel Montagem", route: "/painel-montagem" },
            // { label: "Gestão de OPs", route: "/gestao-op", funcionalidade: 126 },
            // { label: "Planejamento de injeção", route: "/planejamento-injecao" },
            // { label: "Cadastro de parâmetros", route: "/cadastro-parametros" },
          ],
        },
        {
          icone: "icone-checklist",
          subMenus: [
            { label: "Relatório de Inspeções", route: "/relatorio-inspecao" },
            { label: "Parâmetros de inspeção", route: "/parametros-inspecao" },
            { label: "Indicadores de inspeção", route: "/inspecao-indicadores" },
            { label: "Inspeções de primeira peça", route: "/inspecoes-primeira-peca" },
          ],
        },
      ],
    };
  },
};
</script>

<style>
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--cor-separador);
  border-radius: 20px;
}

/* Painel TV: sem header fixo — área útil em altura total */
main.painel-tv-main aside {
  height: 100vh;
}
</style>
